<template>
  <div id="app">
    <SplashScreen v-if="loading" />
    <router-view v-else />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SplashScreen from '@/components/SplashScreen.vue'

export default {
  name: 'App',
  components: {
    SplashScreen,
  },
  data: () => ({
    loading: true,
  }),
  async mounted() {
    await this.getFeedback()
    this.loading = false

    setInterval(() => {
      this.getFeedback()
    }, 5 * 60 * 1000)
  },
  methods: {
    ...mapActions({
      getFeedback: 'dashboard/getFeedback',
    }),
  },
}
</script>

<style lang="scss" scoped>
#app {
  height: 100%;
}
</style>
